export const Pato = (destinationLang) => {
  return [
    {
      FormKey: 'patologoy-lab-route-title',
      Key: 'آزمایشگاه تخصصی',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'patologoy-lab-lam-number',
      Key: 'شماره لام',
      DistinitationLanguage: destinationLang,
    },
  ];
};
